<template>
  <div>
    <v-container grid-list-xs  pt-0>
      <!-- <v-layout row wrap>
        <v-flex lg12>
          <v-flex lg8 offset-lg2 v-if="externalImage">
            <ImageCard :image="externalImage"></ImageCard>
          </v-flex>
        </v-flex>
      </v-layout> -->
      <v-layout row wrap>
        <v-flex lg12>
          <v-flex lg12>
            <!-- <div
              style="overflow: hidden; bottom: 15px">
              <iframe 
                width="100%" 
                :src="externalImage.url" 
                allowfullscreen 
                frameborder="0"
                style="top: 10%; height: 80vh"
              >
              </iframe>
            </div> -->
            <i-frame :url="externalImage.url">
            </i-frame>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
//import ImageCard from "./ImageCard";
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import IFrame from '@/components/IFrame/IFrame';

export default {
  computed: {
    ...mapGetters(["externalImage", "loadingExternal","agency"])
  },
  mounted() {
    
    this.$store.dispatch("external");
    this.iframe.style = {
      position: 'absolute',
      width: window.innerWidth,
      height: window.innerHeight,
      
    }    
    this.iframe.wrapperStyle = {
      overflow: 'hidden',
    }
  },
  components: {
    IFrame
    //ImageCard
  },
  watch: {
    loadingExternal(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando configuración");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val){
      this.$store.dispatch("external");
    }
  },
  data() {
    return {
      iframe: {
        src: window.location.href,
        style: null,
        wrapperStyle: null,
      }
    };
  }
};
</script>